import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FolderMetaDataTabLocales.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {AdvancedLocalePicker} from '../../LocalePicker/AdvancedLocalePicker';
import {Label} from '../../../models/Label';
import cloneDeep from 'lodash/cloneDeep';
import EventEmitter from 'events';
import {getLabelMapKeys} from '../../../utils/StorageObjectUtils';
import {
    FolderMetaDataDialog_changeLabels,
    FolderMetaDataDialog_changeLocales,
    FolderMetaDataTabLocales_changeLocales,
    FolderMetaDataTabMain_changeLabels
} from '../../../init/events';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {STORAGE_OBJECT_OBJECT_LABELS} from '../../../init/storage_object_constants';

export interface FolderMetaDataTabLocalesProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly labels: Map<string, Label>;
    readonly parentLocales: string[];
    readonly defaultLocale: string;
    readonly labelsInitialState: Map<string, Label>;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FolderMetaDataTabLocales
 * @description
 * The dialog to add the metadata of a newly created folder or edited folder - Metadata Tabs
 */
export const FolderMetaDataTabLocales: React.VFC<FolderMetaDataTabLocalesProps> = (props) => {
    const [localesInput, setLocalesInput] = useState<string[]>(getLabelMapKeys(props.defaultLocale, props.labels));
    const [parentLocalesInput] = useState(props.parentLocales ?? []);

    const handleChangeLocalesState = (locales: string[]) => {
        setLocalesInput(locales);
    };

    const handleChangeLocales = (locales: string[]) => {
        setLocalesInput(locales);
        props.eventEmitter.emit(FolderMetaDataDialog_changeLocales, locales);
    };

    const handleResetLocales = () => {
        let labels = cloneDeep(props.labelsInitialState);
        let locales = getLabelMapKeys(props.defaultLocale, labels);
        props.eventEmitter.emit(FolderMetaDataTabMain_changeLabels, labels);
        handleChangeLocales(locales);
        props.eventEmitter.emit(FolderMetaDataDialog_changeLabels, labels);
    };

    props.eventEmitter.on(FolderMetaDataTabLocales_changeLocales, handleChangeLocalesState);

    return (
        <ContentWrapper id={generateIdentifier()}>
            {isVisibleComponent(STORAGE_OBJECT_OBJECT_LABELS, props.templatePropertySettings) &&
                <Accordion accordionHeadline={t('LOCALE_CAPTION')}
                           startOpen>
                    <AdvancedLocalePicker defaultLocale={props.defaultLocale}
                                          locales={localesInput}
                                          parentLocales={parentLocalesInput}
                                          setParentLocales={false}
                                          eventEmitter={props.eventEmitter}
                                          onChange={handleChangeLocales}
                                          onReset={handleResetLocales}/>
                </Accordion>
            }
        </ContentWrapper>
    );
}